import React from 'react';
import styled from 'react-emotion';
import SelectDropdown from './SelectDropdown';
export const SizeSelectorButton = styled('button') `
  width: 45px;
  height: 45px;
  border: 1px solid ${({ theme }) => theme.colors.black};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  text-align: center;
  color: black;
  background-color: transparent;
  display: inline-block;
  margin-right: 0.5rem;
  ${({ selected }) => selected &&
    `
      background-color: black;
      color: white;
   `};
  ${({ disabled }) => disabled &&
    `
      border: 1px solid #C2C2C2;
      color: rgba(0, 0, 0, 0.4);
      cursor: not-allowed;
   `};
`;
const SizeSelectorWrapper = styled('div') `
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  width: 100%;
  margin-bottom: 24px;
`;
const hasLongNames = (sizes) => {
    for (let index = 0; index < sizes.length; index++) {
        const size = sizes[index];
        if (size.value.length > 3) {
            return true;
        }
    }
    return false;
};
const SizeSelector = ({ items, title, SelectComponent, selectedItem, maxButtons = 6, onChange, className }) => {
    if (items) {
        if (items.length > maxButtons || hasLongNames(items)) {
            return (React.createElement(SelectDropdown, { items: items, title: title, selectedItem: selectedItem, SelectComponent: SelectComponent, onChange: onChange }));
        }
        else
            return (React.createElement(SizeSelectorWrapper, { className: className }, items.map(size => (React.createElement(SizeSelectorButton, Object.assign({ type: "button", key: size.value }, size.props, { onClick: () => {
                    onChange && onChange(size);
                    size.props.onClick();
                } }), size.value)))));
    }
    else
        return null;
};
export default SizeSelector;
//# sourceMappingURL=SizeSelector.js.map